import { getTagContent } from "../../../../../common-deprecated/utils";
import { useBnbSelector } from "../../redux/store";
import type { BuildAndBuyLabelType } from "../../utils/labels";
import { getBnbLabel, getBnbOptionalLabel } from "../../utils/labels";
import * as commonSettingsUtils from "../../../../../common-deprecated/settings/utils/commonSettingUtils";

export type LeaseStepsLabelType = {
    icon: string;
    text: string;
    // If the label includes an info tag, include a popover containing the rest in the info tag.
    // See OR-1813
    extraInfo?: string;
    extraText?: string;
};

type ReserveType = {
    labels: LeaseStepsLabelType[];
    enableTermsConditions: boolean;
    showLeaseButton: boolean;
};
const useLease = (): ReserveType => {
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const isLexus = commonSettingsUtils.isLexus(commonSettings);

    const enableTermsConditions =
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseTermsConditionsDescription") ||
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseTermsConditionsScroll1") ||
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseTermsConditionsScroll2") ||
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseTermsConditionsExtra") ||
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseTermsConditionsDescriptionMonthly") ||
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseTermsConditionsScroll1Monthly") ||
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseTermsConditionsScroll2Monthly") ||
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseTermsConditionsExtraMonthly");

    const icons = isLexus
        ? ["login", "lexus-build", "document", "login", "finance", "check"]
        : ["lock", "car", "file-alt", "user", "price-alt", "ok"];

    const labels = icons.reduce((acc: LeaseStepsLabelType[], icon, index) => {
        const label = `leaseStepTitle${index}${financeOption === "monthly" ? "Monthly" : ""}`;

        if (getBnbOptionalLabel({ bnbSettings, commonSettings }, label as BuildAndBuyLabelType)) {
            const item: LeaseStepsLabelType = {
                icon,
                text: getBnbLabel({ bnbSettings, commonSettings }, label as BuildAndBuyLabelType),
            };
            if (item.text.includes("[INFO]")) {
                const leftLabelRegex = new RegExp("(.*)\\[INFO]", "i").exec(item.text) || [];
                const rightLabelRegex = new RegExp("\\[/INFO](.*)", "i").exec(item.text) || [];
                item.extraInfo = getTagContent("INFO", item.text);
                item.extraText = rightLabelRegex![1] || "";
                item.text = leftLabelRegex![1] || "";
            }
            if (item.text) acc.push(item);
        }

        return acc;
    }, []);

    const showLeaseButton =
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseLeaseNow") ||
        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, "leaseLeaseNowMonthly");

    return {
        labels,
        enableTermsConditions,
        showLeaseButton,
    };
};

export default useLease;
